"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _proptypes = require("../../../services/proptypes");

var _GridColumnFlex = _interopRequireDefault(require("../../GridColumnFlex"));

var propTypes = {
  children: _proptypes.ChildrenPropType,
  color: _propTypes["default"].string,
  primary: _propTypes["default"].bool,
  secondary: _propTypes["default"].bool,
  width: _propTypes["default"].string
};
var defaultProps = {
  children: null,
  color: 'transparent',
  primary: false,
  secondary: false,
  width: null
};

function Color(_ref) {
  var children = _ref.children,
      width = _ref.width,
      primary = _ref.primary,
      secondary = _ref.secondary,
      color = _ref.color,
      columnProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "width", "primary", "secondary", "color"]);
  var extraClasses = '';

  if (primary) {
    extraClasses = ' primary';
  } else if (secondary) {
    extraClasses = ' secondary';
  }

  var styles = primary || secondary ? {} : {
    backgroundColor: color
  };
  return /*#__PURE__*/_react["default"].createElement(_GridColumnFlex["default"], (0, _extends2["default"])({
    className: "color-component".concat(extraClasses),
    width: width,
    style: styles
  }, columnProps), children);
}

Color.propTypes = propTypes;
Color.defaultProps = defaultProps;
var _default = Color;
exports["default"] = _default;